import {Async, Loaded, Loading} from 'Core/models/Async';

export class UnassignedSalaryDeductionOccupationClassModel {
  public readonly key = 'UnassignedSalaryDeductionOccupationClassModel';
}

export type SalaryDeductionOccupationClassInfo = {
  saldOccClassInfo: {originalOccClass: string; occClass: string; tierIndicator: string; mentalNervousExclusion: string};
};

export type SalaryDeductionOccupationClassModel =
  | Async<SalaryDeductionOccupationClassInfo>
  | UnassignedSalaryDeductionOccupationClassModel
  | SalaryDeductionOccupationClassInfoWarning;

export class SalaryDeductionOccupationClassInfoWarning {
  public readonly key = 'SalaryDeductionOccupationClassInfoWarning';

  public constructor(public readonly message: string) {}
}

type MatchSalaryDeductionOccupationClassModelOptions<TReturn> = {
  Loading: () => TReturn;
  Loaded: (salaryDeductionOccupationClass: SalaryDeductionOccupationClassInfo) => TReturn;
  Error: () => TReturn;
  Unassigned: (salaryDeductionOccupationClass: {}) => TReturn;
  SalaryDeductionOccupationClassInfoWarning: (message: string) => TReturn;
};

export const isLoading = (
  salaryDeductionOccupationClass: SalaryDeductionOccupationClassModel
): salaryDeductionOccupationClass is Loading<SalaryDeductionOccupationClassInfo> =>
  salaryDeductionOccupationClass.key === 'Loading';

export const isLoaded = (
  salaryDeductionOccupationClass: SalaryDeductionOccupationClassModel
): salaryDeductionOccupationClass is Loaded<SalaryDeductionOccupationClassInfo> =>
  salaryDeductionOccupationClass.key === 'Loaded';

export const matchSalaryDeductionOccupationClassModel = <TReturn>(
  options: MatchSalaryDeductionOccupationClassModelOptions<TReturn>
) => (salaryDeductionOccupationClass: SalaryDeductionOccupationClassModel) => {
  switch (salaryDeductionOccupationClass.key) {
    case 'UnassignedSalaryDeductionOccupationClassModel':
      return options.Unassigned({});
    case 'Loaded':
      return options.Loaded(salaryDeductionOccupationClass.Data);
    case 'Loading':
      return options.Loading();
    case 'Conflict':
      return options.Error();
    case 'ServerError':
      return options.Error();
    case 'Unauthorized':
      return options.Error();
    case 'SalaryDeductionOccupationClassInfoWarning':
      return options.SalaryDeductionOccupationClassInfoWarning(salaryDeductionOccupationClass.message);
  }
};

export const EmptySalaryDeductionOccupationClassModel = new UnassignedSalaryDeductionOccupationClassModel();
